import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from './Components/Header/Header';
import Home from './Components/Pages/Home/Home';
import Footer from './Components/Footer/Footer';
import Aboutus from './Components/Pages/Aboutus/Aboutus';
import Services from './Components/Pages/Services/Services';
import Ourteam from './Components/Pages/OurTeam/Ourteam';
import WhyChooseus from './Components/Pages/WhyChooseus/WhyChooseus';
import Contactus from './Components/Pages/Contectus/Contactus';
import Fulllogistics from './Components/Pages/Services/FulllogisticServices/Fulllogistics';
import Seafreight from './Components/Pages/Services/SeafreightServices/Seafreight';
import Cargo from './Components/Pages/Services/CargoServices/Cargo';
import Road from './Components/Pages/Services/RoadServices/Road';
import Airfreight from './Components/Pages/Services/AirfreightServices/Airfreight';
import ScrollToTop from './Components/ScroolTop/ScrollToTop';
import NotFound from './Components/NotFound/NotFound';
import Blog from './Components/Pages/Blog/Blog';
import ShowBlog from './Components/Pages/Blog/ShowBlogs/ShowBlog';
import AdminLogin from './Components/AdminLogin/AdminLogin';
import CreatBlogs from './DashBoard/CreatBlogs/CreatBlogs';
import ViewBlogs from './DashBoard/VIewBlogs/ViewBlogs';
import UpdateBlogs from './DashBoard/UpdateBlogs/UpdateBlogs';
import Ournetwork from './Components/Pages/Ournetwork/Ournetwork';
import LCL from './Components/Pages/Services/LCL/LCL';
import Chamber from './Components/Pages/Ournetwork/Chamber/Chamber';
import Airsial from './Components/Pages/Ournetwork/Airsial/Airsial';
import Fiata from './Components/Pages/Ournetwork/Fiata/Fiata';
import Piffa from './Components/Pages/Ournetwork/Piffa/Piffa';
import Mundu from './Components/Pages/Ournetwork/Mundu/Mundu';
import Sictl from './Components/Pages/Ournetwork/Sictl/Sictl';
import Loader from './Components/Loader/Loader';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const isLoggedIn = sessionStorage.getItem('admin-login');
  if (!isLoggedIn) {
    return <Navigate to="/adminlogin" replace />;
  }
  return children;
};

// Route change detector component
const RouteChangeDetector = ({ setLoading }) => {
  const location = useLocation();
  
  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // Show loader for 1 second on route change
    
    return () => clearTimeout(timer);
  }, [location.pathname, setLoading]);
  
  return null;
};

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initial loading when the app first loads
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Show loader for 2 seconds on initial load

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && <Loader />}
      <Router>
        <RouteChangeDetector setLoading={setLoading} />
        <ScrollToTop />
        <Routes>
          <Route path='/adminlogin' element={<AdminLogin />} />
          {/* Dashboard Routes - No Header/Footer */}
          <Route path='/dashboard/create-blogs' element={
            <ProtectedRoute>
              <CreatBlogs />
            </ProtectedRoute>
          } />
          <Route path='/dashboard/view-blogs' element={
            <ProtectedRoute>
              <ViewBlogs />
            </ProtectedRoute>
          } />
          <Route path='/dashboard/update-blog/:id' element={
            <ProtectedRoute>
              <UpdateBlogs />
            </ProtectedRoute>
          } />
          {/*Routes for Home page*/}
          <Route path='/' element={
            <>
              <Header />
              <Home />
              <Footer />
            </>
          } />
          {/*Routes for About us */}
          <Route path='/about' element={
            <>
              <Header />
              <Aboutus />
              <Footer />
            </>
          } />
          {/*Routes for Services main*/}
          <Route path='/services' element={
            <>
              <Header />
              <Services />
              <Footer />
            </>
          } />
          {/*Routes for Team*/}
          <Route path='/team' element={
            <>
              <Header />
              <Ourteam />
              <Footer />
            </>
          } />
          {/*Routes for Our Network main*/}
          <Route path='/ournetwork' element={
            <>
              <Header />
              <Ournetwork />
              <Footer />
            </>
          } />
          {/*Routes for Why Choose us */}
          <Route path='/why-choose-us' element={
            <>
              <Header />
              <WhyChooseus />
              <Footer />
            </>
          } />
          {/*Routes for Contact us page*/}
          <Route path='/contact' element={
            <>
              <Header />
              <Contactus />
              <Footer />
            </>
          } />
          {/*Routes for Services Category*/}
          <Route path='/fulllogistic' element={
            <>
              <Header />
              <Fulllogistics />
              <Footer />
            </>
          } />
          <Route path='/seafreight' element={
            <>
              <Header />
              <Seafreight />
              <Footer />
            </>
          } />
          <Route path='/cargo' element={
            <>
              <Header />
              <Cargo />
              <Footer />
            </>
          } />
          <Route path='/road' element={
            <>
              <Header />
              <Road />
              <Footer />
            </>
          } />
          <Route path='/airfreight' element={
            <>
              <Header />
              <Airfreight />
              <Footer />
            </>
          } />
          <Route path='/lcl' element={
            <>
              <Header />
              <LCL />
              <Footer />
            </>
          } />
          {/*Routes for Our Natwork Category*/}
          <Route path='/chamber' element={
            <>
              <Header />
              <Chamber />
              <Footer />
            </>
          } />
          <Route path='/airsial' element={
            <>
              <Header />
              <Airsial />
              <Footer />
            </>
          } />
          <Route path='/fiata' element={
            <>
              <Header />
              <Fiata />
              <Footer />
            </>
          } />
          <Route path='/piffa' element={
            <>
              <Header />
              <Piffa />
              <Footer />
            </>
          } />
          <Route path='/mundu' element={
            <>
              <Header />
              <Mundu />
              <Footer />
            </>
          } />
          <Route path='/sictl' element={
            <>
              <Header />
              <Sictl />
              <Footer />
            </>
          } />
          {/*Routes for Blog & show blog*/}
          <Route path='/blog' element={
            <>
              <Header />
              <Blog />
              <Footer />
            </>
          } />
          <Route path='/blog/:id' element={
            <>
              <Header />
              <ShowBlog />
              <Footer />
            </>
          } />
          {/*Routes for 404 pages*/}
          <Route path='*' element={
            <>
              <Header />
              <NotFound />
              <Footer />
            </>
          } />
        </Routes>
      </Router>
    </>
  );
}

export default App;
